module.exports = __webpack_public_path__ + "img/consent.850899b8.png";